$(function() {

  onChangeCheckbox('#introduction-checkbox', '#contact-introduction-name-bottom')
  onChangeCheckbox('#email-sender-checkbox', '#contact-email-sender')
  onChangeCheckbox('#sns-checkbox', '#contact-sns')
  onChangeCheckbox('#other-checkbox', '#contact-other')

  // 送信時の処理
  $('#contact-submit-btn').on('click', function(e) {

    /* ---------------------------------------------------
    |                   バリデーション                    |
    -----------------------------------------------------*/

    // 入力データ取得
    const officeName = $('#contact-office-name').val()
    const name = $('#contact-name').val()
    const job = $('#contact-job').val()
    const email = $('#contact-email').val()
    const officeAddress = $('#contact-office-address').val()
    const tel1 = $('#contact-tel1').val()
    const tel2 = $('#contact-tel2').val()
    const tel3 = $('#contact-tel3').val()
    const introductionName = $('#contact-introduction-name').val()
    const participantEmail = $('#contact-participant-email').val()
    const contactInterest = $('#contact-interest').val()

    const introductionChecked = $('#introduction-checkbox').prop('checked');
    const emailSenderChecked = $('#email-sender-checkbox').prop('checked');
    const internetChecked = $('#internet-checkbox').prop('checked')
    const snsChecked = $('#sns-checkbox').prop('checked')
    const otherChecked = $('#other-checkbox').prop('checked')

    const introductionNameBottom = $('#contact-introduction-name-bottom').val()
    const emailSender = $('#contact-email-sender').val()
    const sns = $('#contact-sns').val()
    const other = $('#contact-other').val()

    const consentChecked = $('#consent-checkbox').prop('checked')

    // バリデーションメッセージ
    const officeNameValidationMessage = $('#contact-office-name-valid-message')
    const nameValidationMessage = $('#contact-name-valid-message')
    const jobValidationMessage = $('#contact-job-valid-message')
    const emailValidationMessage = $('#contact-email-valid-message')
    const officeAddressValidationMessage = $('#contact-office-address-valid-message')
    const telValidationMessage = $('#contact-tel-valid-message')
    const introductionNameValidationMessage = $('#contact-introduction-name-valid-message')
    const interestValidationMessage = $('#contact-interest-valid-message')
    const contactCheckboxValidationMessage = $('#contact-checkbox-valid-message')
    const introductionNameBottomValidationMessage = $('#contact-introduction-name-bottom-valid-message')
    const emailSenderValidationMessage = $('#contact-email-sender-valid-message')
    const snsValidationMessage = $('#contact-sns-valid-message')
    const otherValidationMessage = $('#contact-other-valid-message')
    const consentValidationMessage = $('#contact-consent-valid-message')

    // バリデーションメッセージ初期化
    officeNameValidationMessage.removeClass('active')
    nameValidationMessage.removeClass('active')
    jobValidationMessage.removeClass('active')
    emailValidationMessage.removeClass('active')
    officeAddressValidationMessage.removeClass('active')
    telValidationMessage.removeClass('active')
    introductionNameValidationMessage.removeClass('active')
    interestValidationMessage.removeClass('active')
    consentValidationMessage.removeClass('active')
    introductionNameBottomValidationMessage.removeClass('active')
    emailSenderValidationMessage.removeClass('active')
    snsValidationMessage.removeClass('active')
    otherValidationMessage.removeClass('active')
    contactCheckboxValidationMessage.removeClass('active')

    // バリデーションチェック
    let isValid = true

    if (officeName === '') {
      officeNameValidationMessage.addClass('active')
      isValid = false
    }

    if (name === '') {
      nameValidationMessage.addClass('active')
      isValid = false
    }

    if (job === '') {
      jobValidationMessage.addClass('active')
      isValid = false
    }

    // メールアドレスの正規チェック
    const emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z]+$/

    if (email === '' || !emailReg.test(email)) {
      emailValidationMessage.addClass('active')
      isValid = false
    }

    if (officeAddress === '') {
      officeAddressValidationMessage.addClass('active')
      isValid = false
    }

    if (tel1 === '' || tel2 === '' || tel3 === '') {
      telValidationMessage.addClass('active')
      isValid = false
    }

    if (introductionName === '') {
      introductionNameValidationMessage.addClass('active')
      isValid = false
    }

    if (contactInterest === '') {
      interestValidationMessage.addClass('active')
      isValid = false
    }

    if(!introductionChecked && !emailSenderChecked && !internetChecked && !snsChecked && !otherChecked) {
      contactCheckboxValidationMessage.addClass('active')
      isValid = false
    }

    if(introductionChecked && introductionNameBottom === '') {
      introductionNameBottomValidationMessage.addClass('active')
      isValid = false
    }

    if(emailSenderChecked && emailSender === '') {
      emailSenderValidationMessage.addClass('active')
      isValid = false
    }

    if(snsChecked && sns === '') {
      snsValidationMessage.addClass('active')
      isValid = false
    }

    if(otherChecked && other === '') {
      otherValidationMessage.addClass('active')
      isValid = false
    }

    if (!consentChecked) {
      consentValidationMessage.addClass('active')
      isValid = false
    }

    if (!isValid) {
      // #contact-formへスムーススクロール
      $('html, body').animate({
        scrollTop: $('#contact').offset().top + -300
      }, 300)
      return
    }

    // ポップアップのinputに値をセットしていく
    $('#contact-modal-office-name').val(officeName) // 事業所名
    $('#contact-modal-name').val(name) // お名前
    $('#contact-modal-job').val(job) // 役職
    $('#contact-modal-email').val(email) // メールアドレス
    $('#contact-modal-office-address').val(officeAddress) // 事業所住所
    $('#contact-modal-tel').val(`${tel1}-${tel2}-${tel3}`) // 電話番号
    $('#contact-modal-introducer-name').val(introductionName) // 紹介者名
    $('#contact-modal-interest-input').val(contactInterest) // 興味がある内容 input
    $('#contact-modal-interest-text').text(contactInterest) // 興味がある内容 text

    const department = $('input[name="所属"]:checked').val()
    const participateNumber = $('input[name="参加人数"]:checked').val()
    const socialGatheringsParticipate = $('input[name="懇親会への参加"]:checked').val()
    const socialGatheringsNumber = $('input[name="懇親会への参加人数"]:checked').val()

    $('#contact-modal-participant-email').val(participantEmail) // 参加者メールアドレス

    $('#contact-modal-department').val(department)
    $('#contact-modal-number-of-people').val(participateNumber)
    $('#contact-modal-socialGatherings-participate').val(socialGatheringsParticipate)
    $('#contact-modal-socialGatherings-number').val(socialGatheringsNumber)


    // 紹介
    if($('#introduction-checkbox').prop('checked')) {
      $('#contact-modal-introduction-name-bottom-wrapper').addClass('active')
      $('#contact-modal-introduction-name-bottom').val('（紹介者のお名前）：' + introductionNameBottom)
      $('#introduction-name-flag').val('true')
    } else {
      $('#contact-modal-introduction-name-bottom-wrapper').removeClass('active')
      $('#contact-modal-introduction-name-bottom').val('（紹介者のお名前）：')
      $('#introduction-name-flag').val('false')
    }

    // メール
    if($('#email-sender-checkbox').prop('checked')) {
      $('#contact-modal-email-sender-wrapper').addClass('active')
      $('#contact-modal-email-sender').val('（メールの送信元）：' + emailSender)
      $('#email-sender-flag').val('true')
    } else {
      $('#contact-modal-email-sender-wrapper').removeClass('active')
      $('#contact-modal-email-sender').val('（メールの送信元）：')
      $('#email-sender-flag').val('false')
    }

    // SNS
    if($('#sns-checkbox').prop('checked')) {
      $('#contact-modal-sns-wrapper').addClass('active')
      $('#contact-modal-sns').val('（該当のSNS）：' + sns)
      $('#sns-flag').val('true')
    } else {
      $('#contact-modal-sns-wrapper').removeClass('active')
      $('#contact-modal-sns').val('（該当のSNS）：')
      $('#sns-flag').val('false')
    }

    // インターネット検索
    if($('#internet-checkbox').prop('checked')) {
      $('#contact-modal-internet-search-wrapper').addClass('active')
      $('#internet-flag').val('true')
    } else {
      $('#contact-modal-internet-search-wrapper').removeClass('active')
      $('#internet-flag').val('false')
    }

    // その他
    if($('#other-checkbox').prop('checked')) {
      $('#contact-modal-other-wrapper').addClass('active')
      $('#contact-modal-other').val('（該当の内容）：' + other)
      $('#other-flag').val('true')
    } else {
      $('#contact-modal-other-wrapper').removeClass('active')
      $('#contact-modal-other').val('（該当の内容）：')
      $('#other-flag').val('false')
    }

    // 確認ポップアップ表示
    $('#contact-modal').addClass('active')
    $('body').addClass('no-scroll')

  })

  $('#contact-modal-back-btn').on('click', function(e) {
    e.preventDefault()
    $('#contact-modal').removeClass('active')
    $('body').removeClass('no-scroll')
  })

})

// チェックボックスをクリックした際の処理
function onChangeCheckbox(checkbox, inputTarget) {
  $(checkbox).on('change', function() {
    if ($(this).prop('checked')) {
      $(inputTarget).prop('disabled', false)
    } else {
      $(inputTarget).attr('disabled', 'disabled')
    }
  })
}